module.exports = __webpack_public_path__ + "static/media/200k.d11b91ed.jpg";